import cn from 'classnames';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import useQuery from 'hooks/useQuery';
import MariaSharapovaLogo from 'images/logo/mariaSharapovaLogo.svg';
import TempoByKrogerLogo from 'images/logo/tempoByKroger.png';
import TempoLogoWhite from 'images/logo/tempoLogoWhite.svg';
import TempoLogoYellow from 'images/logo/tempoYellowLogo.svg';

const HeaderLogo = ({ isSharapova, showPartnershipLogo, partnershipLogo, partnershipData }) => {
  const { isQueryParamTrue: hasKrogerParam } = useQuery('kroger', 'true');
  const tempoLogo = hasKrogerParam ? TempoByKrogerLogo : TempoLogoWhite;
  const altText = hasKrogerParam ? 'Tempo by Kroger Logo' : 'Tempo Logo';

  if (isSharapova) {
    return (
      <div className="mb-3 flex flex-row items-center justify-center bp1:mb-4">
        <img className="w-16 bp1:w-32" src={TempoLogoYellow} alt="Tempo Logo" />
        <div className="mx-3 h-5 w-[1px] bg-[#D3E742] bp1:mx-6 bp1:h-10" />
        <img className="w-24 bp1:w-44" src={MariaSharapovaLogo} alt="Maria Sharapova Logo" />
      </div>
    );
  }

  if (showPartnershipLogo) {
    return (
      <div className="mx-auto flex max-h-[120px] items-start justify-center px-16 py-3">
        {showPartnershipLogo && (
          <img
            className="max-h-[120px] w-auto object-contain"
            src={partnershipLogo}
            alt={`${partnershipData?.partnership.name} logo`}
          />
        )}
      </div>
    );
  }

  return <img className="w-28 pb-2 bp2:w-36" src={tempoLogo} alt={altText} />;
};

HeaderLogo.propTypes = {
  isSharapova: PropTypes.bool,
  showPartnershipOrKrogerSection: PropTypes.bool,
  showPartnershipLogo: PropTypes.bool,
  partnershipLogo: PropTypes.string,
  partnershipData: PropTypes.object,
};

const AdSourceHeaderContent = ({
  isSharapova,
  isMyHealthyDish,
  showPartnershipLogo,
  partnershipLogo,
  partnershipData,
}) => {
  const isSpecialPartnerVariant = isSharapova || isMyHealthyDish || showPartnershipLogo;

  return (
    <div
      className={cn(
        'px-6 py-8 text-center',
        isSharapova ? ' bg-tempo-navy-100' : 'bg-tempo-blue-120',
        isSpecialPartnerVariant ? 'bg-tempo-navy-100' : 'bg-tempo-blue-120'
      )}
    >
      <div className="mx-auto max-w-xl">
        <HeaderLogo
          isSharapova={isSharapova}
          showPartnershipLogo={showPartnershipLogo}
          partnershipLogo={partnershipLogo}
          partnershipData={partnershipData}
        />
        <Heading className="h4 bp1:h2 text-white-100">Fresh, never frozen meal delivery</Heading>
        <Subheading className="text-white-100" brandStylesOverrides="text">
          Prepared, protein-packed meals that cook in 2 minutes.
        </Subheading>
      </div>
    </div>
  );
};

AdSourceHeaderContent.propTypes = {
  isSharapova: PropTypes.bool,
  isMyHealthyDish: PropTypes.bool,
  showPartnershipLogo: PropTypes.bool,
  partnershipLogo: PropTypes.string,
  partnershipData: PropTypes.object,
};

export default AdSourceHeaderContent;
